import { useTranslation, Trans } from "react-i18next";

export default function Terms() {
    const { t } = useTranslation();
    return (
        <>
              <div className=" bg-light">
              <div className="container">
                    <p className=" pt-5"><h4>{t("terms.title")}</h4></p>
                    <p><Trans i18nKey="terms.effective_date" /></p>
                    <p><Trans i18nKey="terms.intro" /></p>
                    <h3>{t("terms.h_acceptance")}</h3>
                    <p>{t("terms.acceptance_text")}</p>
                    <h3>{t("terms.h_account")}</h3>
                    <ul>
                        <li><Trans i18nKey="terms.account_eligibility" /></li>
                        <li><Trans i18nKey="terms.account_security" /></li>
                        <li><Trans i18nKey="terms.account_information" /></li>
                    </ul>
                    <h3>{t("terms.h_use")}</h3>
                    <ul>
                        <li><Trans i18nKey="terms.use_permitted" /></li>
                        <li><Trans i18nKey="terms.use_prohibited" /><ul>
                            <li>{t("terms.prohibited_interfering")}</li>
                            <li>{t("terms.prohibited_viruses")}</li>
                            <li>{t("terms.prohibited_reputation")}</li>
                        </ul>
                        </li>
                    </ul>
                    <h3>{t("terms.h_content")}</h3>
                    <ul>
                        <li><Trans i18nKey="terms.content_ownership" /></li>
                        <li><Trans i18nKey="terms.content_user_license" /></li>
                        <li><Trans i18nKey="terms.content_user_content" /></li>
                    </ul>
                    <h3>{t("terms.h_payments")}</h3>
                    <ul>
                        <li><Trans i18nKey="terms.payments_payments" /></li>
                        <li><Trans i18nKey="terms.payments_refund" /></li>
                        <li><Trans i18nKey="terms.payments_cancellation" /></li>
                    </ul>
                    <h3>{t("terms.h_termination")}</h3>
                    <p>{t("terms.termination_text")}</p>
                    <h3>{t("terms.h_disclaimers")}</h3>
                    <ul>
                        <li><Trans i18nKey="terms.disclaimers_disclaimer" /></li>
                        <li><Trans i18nKey="terms.disclaimers_liability" /></li>
                    </ul>
                    <h3>{t("terms.h_changes")}</h3>
                    <p>{t("terms.changes_text")}</p>
                    <h3>{t("terms.h_governing_law")}</h3>
                    <p>{t("terms.governing_law_text")}</p>
                    <h3>{t("terms.h_contact")}</h3>
                    <p>{t("terms.contact_intro")}</p>
                    <p><strong>Xller</strong><br />{t("terms.email")} <strong>info@xller.com</strong></p>
                </div>
            </div>
        </>
    )
}